import firebase from './firebase';
import 'firebase/compat/database';

const database = firebase.database();

//if (process.env.NODE_ENV === 'development') {
//    firebase.database().useEmulator('localhost', 9000);
//    console.log('DATABASE DE EMULADOR');
//}

export default database;
